// Avoid yup type errors, see https://github.com/jquense/yup/issues/298
export const yupTransformEmptyToUndefined = (
  value: unknown,
  originalValue: unknown,
) =>
  typeof originalValue === "string" && originalValue === "" ? undefined : value;
